import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export const LOCALES = ['en', 'de']
export const LOCALE_STORAGE_KEY = 'iq-lang'

// Each module in ./messages exports { en: {...}, de: {...} }; one module per page/area.
function loadMessages() {
  const modules = require.context('./messages', false, /\.js$/)
  const messages = Object.fromEntries(LOCALES.map(locale => [locale, {}]))
  modules.keys().forEach(key => {
    const mod = modules(key).default
    LOCALES.forEach(locale => Object.assign(messages[locale], mod[locale]))
  })
  return messages
}

function storedLocale() {
  try {
    const value = localStorage.getItem(LOCALE_STORAGE_KEY)
    return LOCALES.includes(value) ? value : 'en'
  } catch (e) {
    return 'en'
  }
}

// Menu items and page titles pass through $t with their plain English text as the key;
// only dotted (namespaced) keys should warn when missing.
const PLAIN_TEXT_KEY = /^[^.]*$/

const i18n = new VueI18n({
  locale: storedLocale(),
  fallbackLocale: 'en',
  messages: loadMessages(),
  silentTranslationWarn: PLAIN_TEXT_KEY,
  silentFallbackWarn: PLAIN_TEXT_KEY,
})

document.documentElement.lang = i18n.locale

export function setLocale(locale) {
  i18n.locale = locale
  document.documentElement.lang = locale
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale)
  } catch (e) {
    // Private mode / blocked storage: the choice just won't survive a reload.
  }
}

export default i18n
